export enum ParentsRelation {
  Father = 1,
  Mother = 2,
  Guardian = 3,
  Other = 4
}

export const ParentsRelationDescriptions: { [key in ParentsRelation]: string } = {
  [ParentsRelation.Father]: 'Father',
  [ParentsRelation.Mother]: 'Mother',
  [ParentsRelation.Guardian]: 'Guardian',
  [ParentsRelation.Other]: 'Other'
};
